var $bfd288727d5cb166$exports = {};
$bfd288727d5cb166$exports = {
  "buttonLabel": "Empfehlungen anzeigen",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " Option");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " Optionen");
      }
    }), " verf\xFCgbar.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Eingetretene Gruppe ".concat(args.groupTitle, ", mit ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " Option");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " Optionen");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", ausgew\xE4hlt",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Empfehlungen",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", ausgew\xE4hlt");
  }
};
export { $bfd288727d5cb166$exports as default };